"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = void 0;
var _social = require("../../types/social");
const defaultState = exports.defaultState = {
  socialType: null,
  socialLoginId: null,
  email: null,
  phone: null,
  authenticate: {
    status: _social.EAuthenticateStatus.Initial
  },
  create: {
    status: _social.ECreateStatus.Initial
  },
  merge: {
    status: _social.EMergeStatus.Initial,
    email: '',
    socialType: _social.ESocialType.VK,
    socialLoginId: ''
  },
  expanded: false
};